import { render } from "./nationList.vue?vue&type=template&id=33335066&scoped=true"
import script from "./nationList.vue?vue&type=script&lang=js"
export * from "./nationList.vue?vue&type=script&lang=js"

import "./nationList.vue?vue&type=style&index=0&id=33335066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33335066"]])

export default __exports__